import Gallus from "./GallusIndustrie.jsx";

function App() {
  return <Gallus />;
}

export default App;
